"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateResponseInterceptor = void 0;
const ResponseInterceptor_1 = require("./ResponseInterceptor");
class DuplicateResponseInterceptor extends ResponseInterceptor_1.ResponseInterceptor {
    constructor(duplicateRequestDetector, axios) {
        super(axios);
        this.duplicateRequestDetector = duplicateRequestDetector;
        this.duplicateRequestDetector = duplicateRequestDetector;
    }
    onFulfilled(response) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(response === null || response === void 0 ? void 0 : response.config)) {
                throw new Error("Request config missing!!!");
            }
            try {
                this.duplicateRequestDetector.clear(response === null || response === void 0 ? void 0 : response.config);
            }
            catch (e) {
                return this.rejectResponse(response === null || response === void 0 ? void 0 : response.config, e.message);
            }
            return response;
        });
    }
    onRejected(error) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(error === null || error === void 0 ? void 0 : error.config)) {
                throw new Error("Request config missing!!!");
            }
            try {
                this.duplicateRequestDetector.clear(error === null || error === void 0 ? void 0 : error.config);
            }
            catch (e) {
                return this.rejectResponse(error === null || error === void 0 ? void 0 : error.config, e.message);
            }
            return Promise.reject(error);
        });
    }
}
exports.DuplicateResponseInterceptor = DuplicateResponseInterceptor;
